import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class UpdateBankAccountCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(bank_account_id:string, cuenta_bancos:string, cuenta_partidas_abiertas:string, owner_name:string): Promise<any> {
    let args = { 
      bank_account_id: bank_account_id,
      cuenta_bancos: cuenta_bancos,
      cuenta_partidas_abiertas: cuenta_partidas_abiertas,
      owner_name: owner_name
    }
    this.frontend.change_loading_update_bank_account(bank_account_id, true)
    await this.dispatcher.dispatch('update_bank_account.data', args)
    this.frontend.change_loading_update_bank_account(bank_account_id, false)
  }
}